module.exports = __webpack_public_path__ + "static/media/Story-Ideation-2.bc930ab6.jpg";